module.exports = __webpack_public_path__ + "static/media/orangecheck.afc377e7.svg";